<div class="deco-line">
    <div class="page-title" *ngIf="showTitle">
        <span class="login-page-title" *ngIf="showTitle">{{ title }}</span>
        <span class="login-page-sub-title" *ngIf="showTitle">{{ subTitle1 }}</span>
        <span class="login-page-sub-title" *ngIf="showTitle">{{ subTitle2 }}</span>
    </div>
</div>
<div class="login-popup">
    <div class="modal-content">
        <router-outlet></router-outlet>
    </div>
</div>
